import { useMutation } from '@tanstack/react-query'
import { queryClient } from 'src'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'
import type {
  PortInfoOperation,
  PortInfoType,
} from '~pages/pages-behind-login/port-info-page/types'

export interface PatchPortInfoPayload {
  type?: PortInfoType
  continentName?: string
  continentCode?: string
  countryName?: string
  countryCode?: string
  subject?: string
  remarks?: string
  vesselName?: string
  imoNumber?: string
  dateOfArrival?: string
  dateOfDeparture?: string
  dateOfInformation?: string
  operation?: PortInfoOperation
  portName?: string
  portCountry?: string
  portCountryCode?: string
  portCode?: string
  portContinentName?: string
  portContinentCode?: string
  terminalName?: string
  berthName?: string
  arrivalDraft?: number
  departureDraft?: number
  airDraft?: number
  cargoType?: string
  ispsSecurityLevel?: string
  cargoConnections?: string
  manifoldPressure?: number
  loadDischargeRate?: number | null
  freshWaterAvailable?: string | null
  garbageLandingAvailable?: string | null
  slopsSludgeLandingAvailable?: string | null
  deSloppingAvailable?: string | null
  dockWaterDensity?: number | null
  generalRemarksCountry?: string | null
  generalRemarksPort?: string | null
  generalRemarksBerthTerminal?: string | null
  generalRemarksDepthAlongside?: string | null
  generalRemarksTideWeather?: string | null
  generalRemarksApproachPilot?: string | null
  generalRemarksTugs?: string | null
  generalRemarksBerthing?: string | null
  generalRemarksMooring?: string | null
  generalRemarksAuthorities?: string | null
  generalRemarksSecurity?: string | null
  generalRemarksCargoOperations?: string | null
  generalRemarksDeparture?: string | null
  generalRemarksOther?: string | null
}

export interface PatchPortInfoProps {
  portInfoId: string
  payload: PatchPortInfoPayload
}

export function usePatchPortInfo() {
  const fetchRequest = useFetch()

  return useMutation({
    mutationFn: ({ portInfoId, payload }: PatchPortInfoProps) =>
      fetchRequest(
        `${apiBase()}/portinfo/${portInfoId}`,
        undefined,
        payload,
        'PATCH',
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['/portinfo'],
      })
    },
  })
}
